export function detectLanguage(scriptTag: HTMLScriptElement | null): 'es' | 'en' {
  const urlLang = new URLSearchParams(window.location.search).get('lang') || '';
  if (urlLang === 'es' || urlLang === 'en') return urlLang;

  const scriptLang = scriptTag ? scriptTag.getAttribute('data-lang') || '' : '';
  if (scriptLang === 'es' || scriptLang === 'en') return scriptLang;

  if (navigator.language.startsWith('es') || document.documentElement.lang.startsWith('es')) return 'es';
  return 'en';
}
